import {
    MEMO_REMINDER_UPDATE_REQUEST,
    MEMO_REMINDER_UPDATE_SUCCESS,
    MEMO_REMINDER_UPDATE_FAILURE
} from "../../../constants"
import { handleHideModal } from "../../../../assets/js/custome";

// import { fetchMemo } from '../../../../services/actions/pharmacy/dispense/fetchAllDispenseListData'

import { update_reminder, update_vials_pack } from "../../../../networking/urlEndPoints"
import {
    showToastMessage,
    hideToastMessage
} from "../../../../assets/js/custome"

import Axios from "../../../../networking/intraceptor"
import { fetchBlisterPacksList } from "../blisters/patientBlisterPackList";
import * as urlEndPoint from '../../../../networking/urlEndPoints'

export const reminderUpdateRequest = (types) => ({
    type: MEMO_REMINDER_UPDATE_REQUEST,
    types: types
})

export const reminderUpdateSuccess = (data, types) => ({
    type: MEMO_REMINDER_UPDATE_SUCCESS,
    payload: data,
    types: types
})

export const reminderUpdateFailure = (error, types) => ({
    type: MEMO_REMINDER_UPDATE_FAILURE,
    payload: error,
    types: types
})

export const updateExpiry = (type, params, showToast, setShowToast, searchParam, setShowModal, showModal) => {

    return async (dispatch) => {

        dispatch(reminderUpdateRequest());
        try {
            const response = await Axios.post(`${update_reminder}`, params)
            if (response?.status === 200) {
                showToastMessage(showToast, setShowToast)
                // dispatch(fetchMemo("memo_list", searchParam));
                handleHideModal(setShowModal, showModal, "MemoExpiryUpdateModal")
                dispatch(reminderUpdateSuccess(response?.data, type))
                setTimeout(() => {
                    hideToastMessage(showToast, setShowToast)
                }, 2000)
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(reminderUpdateFailure(error?.response, type))
            }
        }
    }
}


export const updateProcessingForVials = (type, params, showToast, setShowToast, formData, pageNumber) => {

    return async (dispatch) => {

        dispatch(reminderUpdateRequest());
        try {
            const response = await Axios.post(`${update_vials_pack}`, params)
            if (response?.status === 200) {
                showToastMessage(showToast, setShowToast)

                const params = {
                    page: pageNumber,
                    no_of_records: 25
                };

                if (formData.route) params.route = formData.route;
                if (formData.search) params.search = formData.search;
                if (formData.day) params.rec_day = formData.day.match(/\d+/)[0];
                if (formData.weekday) params.rec_weekday = formData.weekday;
                if (formData.facility) params.facility = formData.facility;
                if (formData.startDate) params.from_date = formData.startDate;
                if (formData.endDate) params.to_date = formData.endDate;

                dispatch(fetchBlisterPacksList('Vials_pack_list', params, urlEndPoint.vials_patient_pack))
                
                setTimeout(() => {
                    hideToastMessage(showToast, setShowToast)
                }, 2000)
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(reminderUpdateFailure(error?.response, type))
            }
        }
    }
}


